<div id="forgot-password" fxLayout="column">
  <div id="login-form-wrapper" fxLayout="column" fxLayoutAlign="center center">
    <div
      id="login-form"
      [class.mat-elevation-z2]="!isActive"
      [class.mat-elevation-z8]="isActive"
      fxLayout="column"
    >
      <div class="logo">
        <img
          src="../../assets/heartcare_logo.png"
          style="height: 100px; width: 100px"
        />
      </div>

      <div class="mat-display-2 title">HeartCare</div>

      <form
        class="card-main"
        name="resetForm"
        [formGroup]="forgotForm"
      >
        <div>
          <mat-form-field appearance="fill">
            <mat-label class="text-muted">Email</mat-label>
            <input
              matInput
              formControlName="resetValue"
              type="email"
              required
              maxlength="50"
              minlength="5"
            />
            <mat-error
              *ngIf="forgotForm.hasError('required', ['resetValue'])"
              >Email address is required.</mat-error
            >
            <mat-error *ngIf="forgotForm.hasError('email', ['resetValue']) || forgotForm.hasError('pattern',['resetValue'])">
              Please enter a valid email address.
            </mat-error>
            <mat-error
              *ngIf="forgotForm.hasError('notRegistered', ['resetValue'])"
              >{{ errMsg }}</mat-error
            >
          </mat-form-field>
          <button
            mat-raised-button
            color="accent"
            class="submit-button mat-body-2"
            aria-label="submit-button"
            [disabled]="forgotForm.invalid"
            color="accent"
            (click)="sendCode()"
          >
            SEND CODE
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
